
import { toast } from "@/hooks/use-toast";
import { CRMData } from "../types";
import { formatDate } from "../../../utils/formatters";
import { exportToCSV, exportToExcel } from "../../../utils/exportData";

export const useExportData = () => {
  const downloadExcel = (filteredData: CRMData[]) => {
    try {
      // Prepare data for export
      const exportData = prepareDataForExport(filteredData);
      
      // Use CSV export with semicolons as separators for compatibility with Excel
      const filename = `CRM_Export_${new Date().toISOString().split('T')[0]}`;
      exportToCSV(exportData, filename);
      
      toast({
        title: "Export CSV réussi",
        description: `${filteredData.length} enregistrements ont été exportés.`,
        duration: 3000,
      });
    } catch (err) {
      console.error("Erreur lors de l'export CSV:", err);
      toast({
        title: "Erreur",
        description: "Impossible d'exporter les données en CSV.",
        variant: "destructive",
      });
    }
  };

  const exportExcel = (filteredData: CRMData[]) => {
    try {
      // Prepare data for export
      const exportData = prepareDataForExport(filteredData);
      
      // Use the Excel export utility
      const filename = `CRM_Export_${new Date().toISOString().split('T')[0]}`;
      exportToExcel(exportData, filename);
      
      toast({
        title: "Export Excel réussi",
        description: `${filteredData.length} enregistrements ont été exportés.`,
        duration: 3000,
      });
    } catch (err) {
      console.error("Erreur lors de l'export Excel:", err);
      toast({
        title: "Erreur",
        description: "Impossible d'exporter les données en Excel.",
        variant: "destructive",
      });
    }
  };

  // Helper function to prepare data in the same format for both export types
  const prepareDataForExport = (data: CRMData[]) => {
    return data.map(item => ({
      "Email": item.email || "",
      "Nom": item.nom || "",
      "Prénom": item.prenom || "",
      "Adresse": item.adresse || "",
      "Ville": item.ville || "",
      "Code Postal": item.code_postal || "",
      "Type Adhésion": item.type_adhesion || "",
      "Date Adhésion": item.date_adhesion ? formatDate(item.date_adhesion) : "",
      "Donateur": item.donateur ? "Oui" : "Non",
      "Date Don": item.date_don ? formatDate(item.date_don) : "",
      "Montant Adhésion": item.montant_adhesion || "",
      "Montant Don": item.montant_don || "",
      "Lien CERFA": item.lien_cerfa || "",
      "Signataire": item.signataire ? "Oui" : "Non",
      "Date Signature": item.date_signature ? formatDate(item.date_signature) : "",
      "Abonné Newsletter": item.abonne_newsletter ? "Oui" : "Non",
      "Date Abonnement Newsletter": item.date_abonnement_newsletter ? formatDate(item.date_abonnement_newsletter) : ""
    }));
  };

  return {
    downloadExcel,
    exportExcel
  };
};
